import _BookmarkBoard from "./bookmark-board.component.js";
import _CreateGroup from "./create-group.component.js";
import _GroupBoard from "./group-board.component.js";
import _FeedBoard from "./feed-board.component.js";
import _HumanTime from "./human-time.component.js";
import _Notification from "./notification.component.js";
import _RandomMessage from "./random-message.component.js";
import _Search from "./search.component.js";
import _Share from "./share.component.js";

export const BookmarkBoard = _BookmarkBoard;
export const CreateGroup = _CreateGroup;
export const GroupBoard = _GroupBoard;
export const FeedBoard = _FeedBoard;
export const HumanTime = _HumanTime;
export const Notification = _Notification;
export const RandomMessage = _RandomMessage;
export const Search = _Search;
export const Share = _Share;
